/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_GuestsInputs */

const en_footer_guests = /** @type {(inputs: Footer_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`And Guestlist brings the guests.`)
};

/**
* | output |
* | --- |
* | "And Guestlist brings the guests." |
*
* @param {Footer_GuestsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_guests = /** @type {((inputs?: Footer_GuestsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_GuestsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_guests(inputs)
});